export enum IconName {
    CORRECT = 'correct',
    WRONG = 'wrong',
    CORRECT_IN_A_BOX = 'correct-in-a-box',
    GMAIL = 'gmail',
    YAHOO = 'yahoo',
    OUTLOOK = 'outlook',
}
